enum ManagedContentName {
  RCRAMinorsStudentAgreement = "RCRAMinorsStudentAgreement",
  RCRAMinorsParentAgreement = "RCRAMinorsParentAgreement",
  RCRAMinorsSchoolAgreement = "RCRAMinorsSchoolAgreement",
  RCRAMinorsSuccess = "RCRAMinorsSuccess",
}

export default ManagedContentName;
